import POLICY_SCHEMA from '../metadata/policySchema.json';

export const PRINCIPAL_TYPES = POLICY_SCHEMA.principalTypes || [
  { value: 'User', label: 'User' },
  { value: 'Agent', label: 'Agent' },
  { value: 'System', label: 'System' },
  { value: 'Service', label: 'Service' },
  { value: 'Workflow', label: 'Workflow' },
  { value: 'Engine', label: 'Engine' },
  { value: 'Handler', label: 'Handler' },
  { value: 'Tool', label: 'Tool' },
  { value: 'ApiClient', label: 'API Client' },
  { value: 'Tenant', label: 'Tenant' },
  { value: 'Role', label: 'Role' },
  { value: 'Group', label: 'Group' },
  { value: 'Application', label: 'Application' },
];

export const ACTION_PRESETS = [
  { value: 'tool:execute', label: 'Execute tool' },
  { value: 'llm:invoke', label: 'Invoke LLM' },
  { value: 'workflow:run', label: 'Run workflow' },
  { value: 'handler:invoke', label: 'Invoke handler' },
  { value: 'api:call', label: 'API call' },
  { value: '*', label: 'All actions' },
];

export const RESOURCE_PRESETS = [
  { value: 'tool:web_search', label: 'Web search tool' },
  { value: 'tool:*', label: 'All tools' },
  { value: 'llm:*', label: 'All LLM resources' },
  { value: 'workflow:*', label: 'All workflows' },
  { value: '*', label: 'All resources' },
];

/** Form row: { type: 'Agent', ids: 'research-agent, analyst-agent' } */
export function emptyPrincipalEntry(type = 'Agent') {
  return { type, ids: '' };
}

export function principalEntriesFromObject(principal) {
  if (!principal || typeof principal !== 'object' || Array.isArray(principal)) {
    return [];
  }
  return Object.entries(principal).map(([type, ids]) => ({
    type,
    ids: Array.isArray(ids) ? ids.join(', ') : String(ids || ''),
  }));
}

export function principalObjectFromEntries(entries) {
  if (!Array.isArray(entries) || !entries.length) return undefined;
  const result = {};
  entries.forEach((entry) => {
    const type = String(entry?.type || '').trim();
    const ids = String(entry?.ids || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    if (!type || !ids.length) return;
    result[type] = [...(result[type] || []), ...ids];
  });
  return Object.keys(result).length ? result : undefined;
}

export function principalLabel(principal) {
  const obj = typeof principal === 'object' && !Array.isArray(principal)
    ? principal
    : principalObjectFromEntries(principal);
  if (!obj) return 'Everyone';
  return Object.entries(obj)
    .map(([type, ids]) => `${type}: ${(ids || []).join(', ')}`)
    .join(' · ');
}

export function normalizePrincipalFormValue(principal) {
  if (Array.isArray(principal) && principal.length && principal[0]?.type) {
    return principal;
  }
  if (typeof principal === 'object' && principal !== null && !Array.isArray(principal)) {
    return principalEntriesFromObject(principal);
  }
  if (typeof principal === 'string' && principal.trim()) {
    return [{ type: 'User', ids: principal }];
  }
  if (Array.isArray(principal) && principal.every((p) => typeof p === 'string')) {
    return [{ type: 'User', ids: principal.join(', ') }];
  }
  return [];
}
